import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'

import './main.css';
import 'bootstrap/dist/css/bootstrap.min.css';

Vue.config.productionTip = false

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
  return '';
})

new Vue({
  render: h => h(App),
}).$mount('#app')
